/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Passkey_LoginInputs */



/**
* | output |
* | --- |
* | "Sign in with Passkey" |
*
* @param {Login_Passkey_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_passkey_login = /** @type {((inputs?: Login_Passkey_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Passkey_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se connecter avec Passkey")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar sesión con Passkey")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entrar com Passkey")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi con Passkey")
	return /** @type {LocalizedString} */ ("Sign in with Passkey")
});